/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsBlockRateFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsBlockRateFormat = ClosedEnum<
  typeof GetApiV3MetricsBlockRateFormat
>;

export type GetApiV3MetricsBlockRateRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsBlockRateFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsBlockRateFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsBlockRateFormat
> = z.nativeEnum(GetApiV3MetricsBlockRateFormat);

/** @internal */
export const GetApiV3MetricsBlockRateFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsBlockRateFormat
> = GetApiV3MetricsBlockRateFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsBlockRateFormat$ {
  /** @deprecated use `GetApiV3MetricsBlockRateFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsBlockRateFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockRateFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsBlockRateFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsBlockRateRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsBlockRateRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsBlockRateFormat$inboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsBlockRateRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsBlockRateRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsBlockRateRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsBlockRateRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsBlockRateFormat$outboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsBlockRateRequest$ {
  /** @deprecated use `GetApiV3MetricsBlockRateRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsBlockRateRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockRateRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsBlockRateRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsBlockRateRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsBlockRateRequest$Outbound;
}

export function getApiV3MetricsBlockRateRequestToJSON(
  getApiV3MetricsBlockRateRequest: GetApiV3MetricsBlockRateRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsBlockRateRequest$outboundSchema.parse(
      getApiV3MetricsBlockRateRequest,
    ),
  );
}

export function getApiV3MetricsBlockRateRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsBlockRateRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3MetricsBlockRateRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsBlockRateRequest' from JSON`,
  );
}
